<template>
  <div v-loading.fullscreen.lock="loading">
    <div class="container-fluid noit-container">
      <div class="row window-height">
        <!-- LEFT: Sign Up Form -->
        <div class="col-12 col-md-6 left-bg">
          <div class="inner-left-wrap p-3 p-md-4">
            <!-- NOIT Logo — top row -->
            <div class="text-center mb-2 anim-fade-in" style="animation-delay: 0.1s">
              <img src="/signup-img/noit/noit-logo.png" alt="NOIT" class="noit-logo" />
            </div>

            <!-- Partner logos — second row -->
            <div class="partner-row mb-3 anim-fade-in" style="animation-delay: 0.2s">
              <img src="/signup-img/noit/besnard-logo.png" alt="Besnard Insurance" class="partner-logo" />
              <img src="/signup-img/noit/dv-logo.png" alt="Dean Villella Agency" class="partner-logo" />
              <img src="/signup-img/noit/gallagher-logo.png" alt="Gallagher" class="partner-logo" />
            </div>

            <!-- Form heading -->
            <div class="signin-header anim-slide-up" style="animation-delay: 0.3s">
              <h3 class="mb-0">Sign Up</h3>
              <span class="d-block mb-3">Welcome! Create your training account.</span>
            </div>

            <!-- Form -->
            <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
              <form role="form" @submit.prevent="handleSubmit(onSubmit)" class="anim-slide-up" style="animation-delay: 0.4s">
                <base-input alternative class="mb-3 login-input singup-input" name="Access Code" :rules="{ required: true }" placeholder="Access Code" v-model="form.code" />

                <div class="row">
                  <div class="col-12 col-md-6">
                    <base-input alternative class="mb-3 login-input singup-input" name="First Name" :rules="{ required: true }" placeholder="First Name" v-model="form.firstName" />
                  </div>
                  <div class="col-12 col-md-6">
                    <base-input alternative class="mb-3 login-input singup-input" name="Last Name" :rules="{ required: true }" placeholder="Last Name" v-model="form.lastName" />
                  </div>
                </div>

                <base-input alternative class="mb-3 login-input singup-input" name="Email" type="email" :rules="{ required: true }" placeholder="Email Address" v-model="form.email" />

                <div class="d-flex justify-content-center signinbtn mb-4">
                  <base-button native-type="submit" class="d-block w-100 mb-1 mb-md-0" :disabled="loading">
                    Sign Up
                    <svg width="20" height="24" viewBox="0 0 20 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M17.5467 10.9333C17.2401 10.5333 16.8667 10.1867 16.5201 9.84C15.6267 9.04 14.6134 8.46667 13.7601 7.62667C11.7734 5.68 11.3334 2.46667 12.6001 0C11.3334 0.306667 10.2267 1 9.28007 1.76C5.82673 4.53333 4.46673 9.42667 6.0934 13.6267C6.14673 13.76 6.20007 13.8933 6.20007 14.0667C6.20007 14.36 6.00007 14.6267 5.7334 14.7333C5.42673 14.8667 5.10673 14.7867 4.8534 14.5733C4.77773 14.5099 4.71444 14.4331 4.66673 14.3467C3.16007 12.44 2.92007 9.70667 3.9334 7.52C1.70673 9.33333 0.4934 12.4 0.666733 15.2933C0.746733 15.96 0.826733 16.6267 1.0534 17.2933C1.24007 18.0933 1.60007 18.8933 2.00007 19.6C3.44007 21.9067 5.9334 23.56 8.6134 23.8933C11.4667 24.2533 14.5201 23.7333 16.7067 21.76C19.1467 19.5467 20.0001 16 18.7467 12.96L18.5734 12.6133C18.2934 12 17.5467 10.9333 17.5467 10.9333ZM13.3334 19.3333C12.9601 19.6533 12.3467 20 11.8667 20.1333C10.3734 20.6667 8.88007 19.92 8.00007 19.04C9.58673 18.6667 10.5334 17.4933 10.8134 16.3067C11.0401 15.24 10.6134 14.36 10.4401 13.3333C10.2801 12.3467 10.3067 11.5067 10.6667 10.5867C10.9201 11.0933 11.1867 11.6 11.5067 12C12.5334 13.3333 14.1467 13.92 14.4934 15.7333C14.5467 15.92 14.5734 16.1067 14.5734 16.3067C14.6134 17.4 14.1334 18.6 13.3334 19.3333Z" fill="white"/>
                    </svg>
                  </base-button>
                </div>

                <p class="signin-link text-center mb-0 mt-3">
                  Already have an account?
                  <router-link to="/login" class="font-weight-bold">Sign In</router-link>
                </p>

                <p class="error" v-if="errors.invalid">{{ errors.invalid }}</p>
              </form>
            </validation-observer>

            <!-- HOT Logo — footer -->
            <div class="text-center mt-2 anim-fade-in" style="animation-delay: 0.7s">
              <img src="/signup-img/hot.svg" alt="Home of Training" class="hot-logo" />
            </div>
          </div>
        </div>

        <!-- RIGHT: Hero Panel -->
        <div class="col-12 col-md-6 right-bg">
          <div class="inner-right-wrap d-flex flex-column h-100 pt-5 pl-2 pl-md-5">
            <div class="mb-3 anim-fade-in" style="animation-delay: 0.2s">
              <img src="/signup-img/noit/msu-logojpg-trimmed.jpg" alt="Manager's Safety University" class="msu-logo-hero" />
            </div>
            <h2 class="text-white mb-2 mb-md-0 anim-slide-up" style="animation-delay: 0.3s">Manage Your System!</h2>
            <p class="text-white mb-5 anim-slide-up" style="animation-delay: 0.45s">
              Enter Your Credentials To Unlock Our Interactive Learning Dashboard.
            </p>
            <div class="img-wrap d-flex justify-content-end mt-auto anim-float-in">
              <img class="img-fluid dashboard-img" src="/signup-img/admin-img.webp" alt="Home of Training Dashboard" />
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import Swal from "sweetalert2/dist/sweetalert2.js";
import "sweetalert2/src/sweetalert2.scss";

export default {
  name: "NOITLanding",
  data() {
    return {
      loading: false,
      form: { code: "", firstName: "", lastName: "", email: "" },
      errors: { invalid: "" },
    };
  },
  methods: {
    async onSubmit() {
      this.loading = true;
      this.errors.invalid = "";
      try {
        const payload = {
          code: this.form.code.trim(),
          first_name: this.form.firstName.trim(),
          last_name: this.form.lastName.trim(),
          email: this.form.email.trim(),
        };
        const resp = await this.$http.post("register-with-code", payload);
        if (resp.data && resp.data.already_exists) {
          Swal.fire({
            title: "Account Already Exists",
            html: `An account with <strong>${payload.email}</strong> already exists.<br/>Please sign in to access your training.`,
            icon: "info",
            confirmButtonText: "Go to Login",
            confirmButtonColor: "#FE672C",
          }).then((result) => {
            if (result.isConfirmed) {
              this.$router.push({ path: "/login", query: { email: payload.email } });
            }
          });
        } else {
          // Auto-login: mirror the production login flow exactly
          const d = resp.data;
          localStorage.setItem("hot-token", d.token);
          localStorage.setItem("hot-user", "employee");
          localStorage.setItem("hot-sidebar", "employee");
          localStorage.setItem("hot-logged-user", d.user_id);
          localStorage.setItem("hot-user-full-name", d.full_name);
          this.$http.defaults.headers.authorization = "Bearer " + d.token;

          // Call the same user_data endpoint the production login uses
          try {
            const userData = await this.$http.post("employees/user_data", {
              user_name: this.form.email.trim()
            });
            if (userData.data && userData.data[0]) {
              localStorage.setItem("hot-user-id", userData.data[0].id);
              localStorage.setItem("hot-user-name", userData.data[0].full_name);
              localStorage.setItem("hot-user-number", userData.data[0].phone_num);
            }
          } catch (e) {
            // Fallback — set user_id from registration response
            localStorage.setItem("hot-user-id", d.user_id);
          }

          Swal.fire({
            title: "Welcome, " + this.form.firstName + "!",
            text: "Your account has been created. Your login credentials have been sent to your email.",
            icon: "success",
            confirmButtonText: "Go to Dashboard",
            confirmButtonColor: "#FE672C",
            timer: 4000,
            timerProgressBar: true,
          }).then(() => {
            this.$router.push("/dashboard");
          });
        }
      } catch (error) {
        let errorText = "Something went wrong. Please try again.";
        if (error.response && error.response.status === 422) errorText = error.response.data.message;
        else if (error.response && error.response.status === 403) errorText = "Invalid access code. Please check and try again.";
        this.errors.invalid = errorText;
        Swal.fire({ title: "Error", text: errorText, icon: "error", confirmButtonColor: "#1B0F87" });
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
html, body, .window-height {
  height: 100vh;
}

.noit-container {
  font-family: "Inter", "Nunito", sans-serif;
  color: #1e1e1e;
}

/* ===== Left Panel ===== */
.left-bg {
  background: #f3f3f3 url("/signup-img/signup_bg1.svg") no-repeat right bottom;
  display: flex;
  align-items: flex-start;
  padding-top: 3vh;
}

.inner-left-wrap {
  width: 100%;
  max-width: 460px;
  margin: 0 auto;
}

.noit-logo {
  max-width: 180px;
  height: auto;
  mix-blend-mode: multiply;
}

.partner-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
}

.partner-logo {
  max-height: 32px;
  max-width: 110px;
  width: auto;
  height: auto;
  object-fit: contain;
  mix-blend-mode: multiply;
}

.signin-header h3 {
  font-size: 32px;
  font-weight: 700;
  color: #1e1e1e;
  line-height: 40px;
}

.signin-header span {
  font-size: 15px;
  color: #6b7280;
}

.signin-link {
  font-size: 14px;
  color: #6b7280;
}

.signin-link a {
  color: #1B0F87;
}

/* Button — same orange as production login */
.signinbtn .btn {
  background: linear-gradient(to bottom, #e48e39 0%, #ea2628 100%);
  border: 0;
  height: clamp(40px, 6vw, 60px);
  font-size: clamp(20px, 2.5vw, 25px);
  font-weight: normal;
  transform: none;
}

.signinbtn .btn:hover {
  opacity: .8;
}

.signinbtn .btn svg {
  margin-top: -4px;
}

/* MSU on right panel */
.msu-logo-hero {
  max-width: 240px;
  height: auto;
  border-radius: 6px;
}

.hot-logo {
  max-width: 80px;
  height: auto;
}

.error {
  color: red;
  text-align: center;
}

/* ===== Right Panel ===== */
.right-bg {
  background: url("/signup-img/signup_bg2.svg") no-repeat center center;
  background-size: cover;
}

.img-wrap {
  margin-right: -15px;
}

.inner-right-wrap h2 {
  font-size: 42px;
  font-weight: 700;
  line-height: 1.15;
}

.inner-right-wrap p {
  font-size: 18px;
  max-width: 75%;
  opacity: 0.85;
}

/* ===== Modal ===== */
.modal-title {
  font-size: 22px;
  font-weight: 700;
  color: #1e1b4b;
}

.success-content {
  text-align: center;
  padding: 16px 0;
}

.success-icon {
  margin-bottom: 16px;
}

/* ===== Animations ===== */
@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes slideUp {
  from { opacity: 0; transform: translateY(24px); }
  to { opacity: 1; transform: translateY(0); }
}

@keyframes floatIn {
  from { opacity: 0; transform: translateX(40px) translateY(20px); }
  to { opacity: 1; transform: translateX(0) translateY(0); }
}

@keyframes gentleFloat {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-8px); }
}

@keyframes btnGlow {
  0%, 100% { box-shadow: 0 0 0 0 rgba(228, 142, 57, 0); }
  50% { box-shadow: 0 0 20px 4px rgba(228, 142, 57, 0.25); }
}

.anim-fade-in {
  opacity: 0;
  animation: fadeIn 0.6s ease-out forwards;
}

.anim-slide-up {
  opacity: 0;
  animation: slideUp 0.6s ease-out forwards;
}

.anim-float-in {
  opacity: 0;
  animation: floatIn 0.8s cubic-bezier(0.16, 1, 0.3, 1) 0.5s forwards;
}

/* Dashboard floats gently after entrance */
.dashboard-img {
  max-height: 55vh;
  object-fit: contain;
  animation: gentleFloat 4s ease-in-out 1.5s infinite;
}

/* Button subtle glow pulse */
.signinbtn .btn {
  animation: btnGlow 2.5s ease-in-out 1s infinite;
}

/* Partner logos hover lift */
.partner-logo {
  transition: transform 0.25s ease, filter 0.25s ease;
}

.partner-logo:hover {
  transform: translateY(-2px);
}

/* Input focus glow */
::v-deep .singup-input .input-group-alternative.focused {
  box-shadow: 0 2px 12px rgba(228, 142, 57, 0.12) !important;
  transition: box-shadow 0.3s ease;
}

/* ===== Responsive ===== */
@media (max-width: 767px) {
  .window-height {
    height: auto;
    min-height: 100vh;
  }

  .inner-left-wrap {
    padding: 24px 16px !important;
  }

  .noit-logo {
    max-width: 140px;
  }

  .partner-logo {
    max-height: 24px;
    max-width: 80px;
  }

  .partner-row {
    gap: 12px;
  }

  .signin-header h3 {
    font-size: 26px;
    line-height: 32px;
  }

  .singup-input .form-control {
    height: 50px !important;
  }

  .signinbtn .btn {
    height: 50px;
  }

  .msu-logo-hero {
    max-width: 170px;
  }

  .inner-right-wrap h2 {
    font-size: 28px;
  }

  .inner-right-wrap p {
    font-size: 16px;
    max-width: 100%;
  }
}
</style>
